import { Networks } from "stellar-sdk";

const NETWORK = {
  available: {
    test: {
      horizonURL: "https://horizon-testnet.cryptops.exchange",
      networkPassphrase: "Test Cryptops Network ; January 2018",
    },
    public: {
      horizonURL: "https://horizon.cryptops.exchange",
      networkPassphrase: "Public Global Cryptops Network ; January 2018",
    },
  },
  defaultName: "test",
};
export default NETWORK;
